import {formatDate} from '../../util';

interface DataViewHeaderProps {
    header: string[];
    createdAt: Date;
    data: any[];
}

const DataViewRow: React.FC<DataViewHeaderProps> = (props: DataViewHeaderProps) => {
    return (
        <tr>
            <th>{formatDate(props.createdAt, 'yyyy-MM-dd HH:mm:ss')}</th>
            {props.data.map((value, index) => {
                return <td key={index}>{value}</td>;
            })}
        </tr>
    );
};

export default DataViewRow;
